/* ==========================================================================
   RIDER-ID Designer – Schale des Vollbild-Werkzeugs
   Laeuft NUR auf templates/product.designer.liquid, nach riderid.js.
   Greift bewusst nicht in riderid.js ein: die Klappfelder bleiben im DOM,
   diese Datei verdrahtet nur Werkzeugleiste, Einstellungsfeld und Kopfleiste
   und hoert per MutationObserver mit, wenn riderid.js selbst ein Feld oeffnet
   (z.B. Klick auf Zahl/Name in der Vorschau).
   ========================================================================== */
(function () {
  'use strict';

  var app = document.getElementById('riderid-app');
  if (!app || app.getAttribute('data-mode') !== 'designer') return;

  var TITLES = {
    rider: 'Startnummer & Name',
    size: 'Druckgröße',
    font: 'Schriftstil',
    color: 'Farben & Konturen',
    design: 'Muster & Texturen',
    flag: 'Land / Flagge'
  };
  var SUMS = {
    rider: 'sumRider', size: 'sumSize', font: 'sumFont',
    color: 'sumColor', design: 'sumDesign', flag: 'sumFlag'
  };

  var ORDER = ['rider', 'size', 'font', 'color', 'design', 'flag'];
  var pills = {}, railBtns = {};
  app.querySelectorAll('[data-pill]').forEach(function (p) {
    var k = p.getAttribute('data-pill');
    if (k) pills[k] = p;
  });
  app.querySelectorAll('.rid-rail-btn').forEach(function (b) {
    railBtns[b.getAttribute('data-group')] = b;
  });

  var panelTitle = document.getElementById('ridPanelTitle');
  var current = null, muteObserver = false, busy = false;

  // „Weiter" sitzt im schwarzen Kopf des Feldes (wie in der Vorlage)
  var nextBtn = document.getElementById('ridNext');
  var nextTxt = nextBtn ? nextBtn.querySelector('.rid-next-t') : null;

  function refreshNext() {
    if (!nextBtn) return;
    var i = ORDER.indexOf(current);
    var last = i === ORDER.length - 1;
    nextBtn.classList.toggle('last', last);
    if (nextTxt) nextTxt.textContent = last ? 'Fertig' : 'Weiter';
    nextBtn.title = last ? 'Einstellungen schließen und Design ansehen'
                         : 'Weiter zu: ' + TITLES[ORDER[i + 1]];
  }
  if (nextBtn) nextBtn.addEventListener('click', function () {
    var i = ORDER.indexOf(current);
    if (i === ORDER.length - 1) setPanel(false);
    else show(ORDER[i + 1]);
  });

  /* ------------------------- Feld & Werkzeugleiste ----------------------- */

  function setPanel(open) {
    app.setAttribute('data-panel', open ? 'open' : 'closed');
    // Zugeklappt ist keine Gruppe „in Arbeit“ – sonst bliebe ein Knopf schwarz stehen.
    Object.keys(railBtns).forEach(function (k) {
      railBtns[k].classList.toggle('on', open && k === current);
    });
  }

  function show(group) {
    if (!pills[group] || busy) return;
    busy = true;
    muteObserver = true;          // eigene Klassenwechsel nicht wieder einfangen
    current = group;
    Object.keys(pills).forEach(function (k) {
      pills[k].classList.toggle('rid-active', k === group);
    });
    if (panelTitle) panelTitle.textContent = TITLES[group] || '';
    setPanel(true);
    // riderid.js fuehrt seine eigene Auf/Zu-Logik: genau die gezeigte Gruppe
    // offen halten, alle anderen schliessen – sonst kaeme der Beobachter
    // unten bei zwei offenen Gruppen ins Schaukeln.
    Object.keys(pills).forEach(function (k) {
      var head = pills[k].querySelector('.pill-head');
      var isOpen = pills[k].classList.contains('open');
      if (head && ((k === group && !isOpen) || (k !== group && isOpen))) head.click();
    });
    pills[group].scrollTop = 0;
    refreshNext();
    busy = false;
    setTimeout(function () { muteObserver = false; }, 0);
  }

  Object.keys(railBtns).forEach(function (k) {
    railBtns[k].addEventListener('click', function () {
      if (current === k && app.getAttribute('data-panel') === 'open') setPanel(false);
      else show(k);
    });
  });

  var panelClose = document.getElementById('ridPanelClose');
  if (panelClose) panelClose.addEventListener('click', function () { setPanel(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && app.getAttribute('data-panel') === 'open' && !app.querySelector('.mask.show')) {
      setPanel(false);
    }
  });

  // riderid.js oeffnet Felder selbst (Klick auf Zahl/Name in der Vorschau,
  // „Muster ›"-Abkuerzung, Deep-Links) -> Werkzeugleiste zieht mit.
  var obs = new MutationObserver(function (list) {
    if (muteObserver) return;
    for (var i = 0; i < list.length; i++) {
      var p = list[i].target;
      if (p.classList.contains('open') && p.getAttribute('data-pill') !== current) {
        show(p.getAttribute('data-pill'));
        break;
      }
    }
  });
  Object.keys(pills).forEach(function (k) {
    obs.observe(pills[k], { attributes: true, attributeFilter: ['class'] });
  });

  /* ------------------------------ Kopfleiste ----------------------------- */

  var stateEl = document.getElementById('ridTopState');
  var totalEl = document.getElementById('ridTopTotal');
  var priceEl = document.getElementById('ridPrice');
  var cta = document.getElementById('cta');
  var atc = document.getElementById('ridTopAtc');
  var atcLabel = atc ? atc.querySelector('.rid-atc-t') : null;

  function txt(id) {
    var el = document.getElementById(id);
    return el ? (el.textContent || '').trim() : '';
  }

  function refreshState() {
    if (!stateEl) return;
    var num = (document.getElementById('num') || {}).value || '';
    var name = (document.getElementById('name') || {}).value || '';
    var size = txt('sumSize');
    var bits = [];
    if (num.trim()) bits.push('<b>' + esc(num.trim()) + '</b>');
    if (name.trim()) bits.push('<b>' + esc(name.trim()) + '</b>');
    if (size) bits.push(esc(size));
    stateEl.innerHTML = bits.length ? bits.join(' <i>·</i> ') : 'Startnummer und Name eingeben';

  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function refreshPrice() {
    if (!totalEl || !priceEl) return;
    var v = (priceEl.textContent || '').trim();
    var visible = v && !priceEl.hasAttribute('hidden');
    totalEl.hidden = !visible;
    if (visible) totalEl.querySelector('.rid-total-v').textContent = v;
  }

  // Warenkorb-Knopf der Kopfleiste loest den vorhandenen Knopf aus (gleiche
  // Logik, gleiche Eigenschaften) und spiegelt dessen Beschriftung.
  if (atc && cta) {
    atc.addEventListener('click', function () { cta.click(); });
    var ctaObs = new MutationObserver(function () {
      var t = (cta.textContent || '').trim();
      var busy = /…|\.\.\./.test(t);
      if (atcLabel && t) atcLabel.textContent = t;
      if (busy) atc.setAttribute('data-busy', '1'); else atc.removeAttribute('data-busy');
    });
    ctaObs.observe(cta, { childList: true, characterData: true, subtree: true });
    if ((cta.textContent || '').trim()) {
      var t0 = cta.textContent.trim();
      if (atcLabel && t0.length < 28) atcLabel.textContent = t0;
    }
  }

  if (priceEl) {
    new MutationObserver(refreshPrice).observe(priceEl, {
      childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden']
    });
  }

  app.addEventListener('input', refreshState);
  app.addEventListener('click', function () { setTimeout(refreshState, 40); });

  /* ------------------------ Warenkorb-Bestaetigung ----------------------- */

  var done = document.getElementById('ridDone');
  var hook = app.querySelector('.rid-cart-hook');
  var doneSum = document.getElementById('ridDoneSum');
  var doneBack = document.getElementById('ridDoneBack');

  function showDone() {
    if (!done) return;
    if (doneSum) {
      var num = ((document.getElementById('num') || {}).value || '').trim();
      var name = ((document.getElementById('name') || {}).value || '').trim();
      var bits = [];
      if (num) bits.push('Startnummer ' + num);
      if (name) bits.push('Name ' + name);
      var size = txt('sumSize'); if (size) bits.push(size);
      var price = totalEl && !totalEl.hidden ? (totalEl.querySelector('.rid-total-v').textContent || '').trim() : '';
      if (price) bits.push(price);
      doneSum.textContent = bits.join(' · ');
    }
    done.hidden = false;
    var first = done.querySelector('.rid-done-primary');
    if (first) first.focus();
  }
  function hideDone() { if (done) done.hidden = true; }

  // riderid.js klickt diesen Auslöser nach erfolgreichem Hinzufuegen
  if (hook) hook.addEventListener('click', showDone);
  if (doneBack) doneBack.addEventListener('click', hideDone);
  if (done) done.addEventListener('click', function (e) { if (e.target === done) hideDone(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && done && !done.hidden) { hideDone(); e.stopPropagation(); }
  }, true);

  /* -------------------------------- Start -------------------------------- */

  show('rider');
  refreshState();
  refreshPrice();
  setTimeout(function () { refreshState(); refreshPrice(); }, 600);
})();

